import {createRouter, createWebHistory} from "vue-router";


/*
    FIXME child pages för bvBetalningsId
    title används det?
*/
const router = createRouter({
    base: process.env.BASE_URL,
    history: createWebHistory(),
    routes: [
        {
            path: "/:bvBetalningsId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})",
            meta: {
                title: "Betalning",
            },
            name: "home",
            component: () =>
                import ("./pages/home.vue"),
        },
        {
            path: "/:bvBetalningsId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/netaxeptError",
            meta: {
                title: "Betalning",
            },
            name: "errorNetaxept",
            component: () =>
                import ("./pages/errorNetaxept.vue"),
        },
        {
            path: '/:pathMatch(.*)*',
            name: "404",
            component: () =>
                import ("./pages/404.vue"),
        },
    ],
});
router.beforeEach((to, from, next) => {
	document.title = to.meta.title;
	next();
});
export default router;